import * as React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'pc/reducer'
import { styling } from 'common/utils'
import { DynamicCx } from 'common/types'
import * as s from './gnb.scss'
import CategoryLayer from './CategoryLayer'
import { CategoryState, closeCategory, setCategory } from 'pc/components/Common/Header/ducks/gnb/category'
import OutsideClick from 'common/components/OutsideClick'
import Category from 'common/constants/category'

interface OwnProps {
  cx?: DynamicCx
}

interface StateProps {
  category: CategoryState
}

interface DispatchProps {
  setCategory: typeof setCategory
  closeCategory: typeof closeCategory
}

type Props = OwnProps & DispatchProps & StateProps

const CategoryButton: React.SFC<Props> = props => {
  const { cx, category, setCategory, closeCategory } = props
  const { selected, activated } = category
  const handleClickCategoryButton = (selectedCategory: Category) => {
    if (activated && !selectedCategory) {
      closeCategory()
    } else {
      selectedCategory ? setCategory(selectedCategory) : selected ? setCategory(selected) : setCategory(Category.WEAR)
    }
  }

  const closeCategoryLayer = e => {
    const targetId = e.target.id
    if (['digital', 'birth'].includes(targetId)) return
    closeCategory()
  }

  return (
    <div className={cx('category_button')}>
      <button
        id="digital"
        type="button"
        className={cx('digital', '@N=a:SNB.digicate', { active: activated && selected === Category.DIGITAL })}
        onClick={() => handleClickCategoryButton(Category.DIGITAL)}>
        디지털/가전
      </button>
      <button
        id="birth"
        type="button"
        className={cx('birth', '@N=a:SNB.babycate', { active: activated && selected === Category.BIRTH })}
        onClick={() => handleClickCategoryButton(Category.BIRTH)}>
        출산/육아
      </button>
      <button
        type="button"
        className={cx('category', `${activated ? 'active' : ''}`, '@N=a:SNB.category')}
        onClick={() => handleClickCategoryButton(null)}>
        카테고리
      </button>
      <OutsideClick onClickOutside={closeCategoryLayer} isRendered={activated} stopPropagation={false}>
        <CategoryLayer />
      </OutsideClick>
    </div>
  )
}

export default connect<StateProps, DispatchProps, OwnProps>(
  (state: RootState) => ({
    category: state.gnb.category,
  }),
  {
    setCategory,
    closeCategory,
  },
)(styling(s)(CategoryButton))
